const GallerySvg = ({
  width = 12,
  height = 12,
  viewBox = '0 0 12 12',
  className,
}: {
  height?: any;
  width?: any;
  viewBox?: any;
  className?: string;
}) => {
  return (
    <svg width={width} height={height} fill="none" viewBox={viewBox} className={className}>
      <path
        d="M1.33333 12C0.966667 12 0.652889 11.8696 0.392 11.6087C0.131111 11.3478 0.000444444 11.0338 0 10.6667V1.33333C0 0.966667 0.130667 0.652889 0.392 0.392C0.653333 0.131111 0.967111 0.000444444 1.33333 0H10.6667C11.0333 0 11.3473 0.130667 11.6087 0.392C11.87 0.653333 12.0004 0.967111 12 1.33333V10.6667C12 11.0333 11.8696 11.3473 11.6087 11.6087C11.3478 11.87 11.0338 12.0004 10.6667 12H1.33333ZM1.33333 10.6667H10.6667V1.33333H1.33333V10.6667ZM2 9.33333H10L7.5 6L5.5 8.66667L4 6.66667L2 9.33333Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default GallerySvg;
